import { Component } from '@angular/core';

import { MatDialogClose } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-instruction-for-supplier-modal',
  imports: [MatDialogClose, TranslatePipe, MatIcon],
  templateUrl: './instruction-for-supplier-modal.component.html',
  styleUrl: './instruction-for-supplier-modal.component.scss'
})
export class InstructionForSupplierModalComponent {
  public downloadPdf(): void {
    const link = document.createElement('a');
    link.href = 'assets/documents/Інструкція для постачальника.pdf';
    link.download = 'Інструкція для постачальника.pdf';
    link.click();
  }
}
